import React, { Component } from "react";

// import Typography from '@material-ui/core/Typography';

import FundRatesUploadFunction from "./fundRatesUploadFunction";
import { withFirebase } from "../../../Firebase";
import { withRouter } from "react-router-dom";
import { compose } from "recompose";
import withAuthorization from "../../../Session/withAuthorization";

import Navigation from "../../../Navigation";

const FundRatesUploadPage = () => {
  return (
    <>
      <Navigation content={<FundRatesUploadForm />} />
    </>
  );
};

class FundRatesUploadPageBase extends Component {
  render() {
    return (
      <>
        <FundRatesUploadFunction props={this.props} />
        <label
          variant="caption"
          style={{
            display: "block",
            marginBottom: "auto",
            textAlign: "center",
            fontSize: "12px",
          }}
        >
          Copyright &copy; {new Date().getFullYear()} RAMPVER. All rights
          reserved.
        </label>
      </>
    );
  }
}

const condition = (authUser) => !!authUser;

const FundRatesUploadForm = compose(
  withAuthorization(condition),
  withRouter,
  withFirebase
)(FundRatesUploadPageBase);

export default FundRatesUploadPage;

export { FundRatesUploadForm };
